import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { getStyles } from './styles';

export default function AssessmentDatesTab() {
  const theme = useTheme();
  const styles = getStyles(theme);

  return (
    <Typography sx={styles.tabContent} component="div">
      Manage Assessment Dates content will go here.
    </Typography>
  );
}
